import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-93407582")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加分类")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#1890ff"} }, "sss", -1)
const _hoisted_5 = { class: "right" }
_popScopeId()

import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { getSortList } from '@/services/appreciation'
import Edit from './Edit'


export default {
  setup(__props) {

const router = useRouter()

const pageState = reactive({})

const current = ref({})

const treeState = reactive({
  data: null,
  expandedKeys: [],
  nodeList: []
})

const getData = async () => {
  const { items } = await getSortList()
  treeState.nodeList = items
  const data = getTreeData(0, items)
  treeState.data = [{ key: 0, title: '根节点', children: data }]
}

// 构造菜单树数据
const getTreeData = (pid, menus) =>
  menus
    .filter(item => item.pid === pid)
    .map(item => {
      if (menus.filter(menu => menu.pid === item.id).length === 0) {
        return { title: item.name, key: item.id }
      }
      if (pid === 0) {
        treeState.expandedKeys.push(item.id.toString())
      }
      return {
        title: item.name,
        key: item.id,
        children: getTreeData(item.id, menus)
      }
    })

const handleCreate = () => {
  current.value = {}
}

const handleFormSave = () => {
  current.value = {}
  getData()
}
const getNodeFullPath = (id, path = []) => {
  const node = treeState.nodeList.filter(i => id === i.id)[0] ?? {}
  if (node.pid >= 0) {
    path.unshift(node.pid)
    return getNodeFullPath(node.pid, path)
  }
  return path
}

const handleSelectNode = (node, e) => {
  if (node[0] === 0) {
    current.value = {}
  } else {
    current.value = {
      ...treeState.nodeList.filter(i => node[0] === i.id)[0] ?? {},
      path: getNodeFullPath(node[0])
    }
  }
}

onBeforeMount(() => {
  getData()
})


return (_ctx, _cache) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_tree = _resolveComponent("a-tree")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_card, {
        bordered: "",
        title: "赏析资源分类",
        style: {height:'100%'}
      }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: handleCreate
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_tree, {
            expandedKeys: _unref(treeState).expandedKeys,
            onSelect: handleSelectNode,
            "tree-data": _unref(treeState).data,
            "onUpdate:expandedKeys": _cache[0] || (_cache[0] = $event => (_unref(treeState).expandedKeys = $event))
          }, {
            title0010: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["expandedKeys", "tree-data"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Edit), {
        current: current.value,
        "tree-data": _unref(treeState).data,
        onOnSave: handleFormSave
      }, null, 8, ["current", "tree-data"])
    ])
  ]))
}
}

}